import React from 'react';
// Script Path & Filename: S2/frontend/src/main.jsx
import ReactDOM from 'react-dom/client';
import App from './App';

// Silence Vite/blob insecure connection warnings in dev environment over HTTP
const originalWarn = console.warn;
console.warn = (...args) => {
    if (args[0] && typeof args[0] === 'string' && args[0].includes('was loaded over an insecure connection') && args[0].includes('blob:')) {
        return;
    }
    originalWarn(...args);
};

const originalError = console.error;
console.error = (...args) => {
    if (args[0] && typeof args[0] === 'string' && args[0].includes('was loaded over an insecure connection') && args[0].includes('blob:')) {
        return;
    }
    originalError(...args);
};

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);